/**
 * BtybMarketerRoutes.jsx — dashboard for users.role === btybMarketer.
 * Shaped by: owner request for a BTYB Marketer role.
 * Invariants: this role sees the city CPM auction and settings only.
 * Related: BtybAuctionPage.jsx, DashboardPage.jsx.
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Settings from "components/dashboard/Settings";
import BtybAuctionPage from "pages/dashboard/btyb/BtybAuctionPage";
import DashboardLayout from "components/dashboard/DashboardLayout";
import { useAuth } from "hooks/useAuth";

const BtybMarketerRoutes = () => {
  const { user, subscription } = useAuth();

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard/btyb" replace />} />
        <Route path="/btyb" element={<BtybAuctionPage />} />
        <Route
          path="/settings"
          element={<Settings uid={user?.uid} subscription={subscription} />}
        />
        <Route path="*" element={<Navigate to="/dashboard/btyb" replace />} />
      </Routes>
    </DashboardLayout>
  );
};

export default BtybMarketerRoutes;
